import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';
import { updateAction } from '../../api/production-request-api/index.js';

/**
 * Hook containing mutation function for updating an Action.
 */
export const useUpdateAction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call updateAction.
     * @param {object} params - The parameters for updating the Action.
     * @param {string} params.id - The ID of the Action to update.
     * @param {Local.ActionMutationInput} params.input - The inputs for updating the Action.
     */
    mutationFn: (params) => updateAction(params.id, params.input),
    onSuccess: () => {
      toast.success('Action updated successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ACTION_DATA] });
    },
  });
};
